import { axios } from '@Root/API'

export const get = (studyProgrammeId, studentFinancialSupportId) => {
	return axios.get(`course-session/${studyProgrammeId}/student-financial-support/${studentFinancialSupportId}`)
}
